document.addEventListener('DOMContentLoaded', () => {
    const lightbox = document.getElementById('image-lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    const closeBtn = document.getElementById('lightbox-close');

    // Make all images clickable
    document.querySelectorAll('img.zoom-image').forEach((img) => {
        img.classList.add('lightbox-trigger');
        img.addEventListener('click', () => {
            lightboxImg.src = img.src;
            lightboxImg.classList.remove('zoomed');
            lightboxImg.style.transform = 'scale(1)';
            lightboxImg.style.maxWidth = '90vw';
            lightboxImg.style.maxHeight = '90vh';
            lightboxImg.style.cursor = 'zoom-in';
            lightbox.style.display = 'flex';
        });
    });

    // Zoom toggle on image click
    lightboxImg.addEventListener('click', (e) => {
        e.stopPropagation();
        const isZoomed = lightboxImg.classList.toggle('zoomed');
        if (isZoomed) {
            lightboxImg.style.transform = 'scale(2)';
            lightboxImg.style.maxWidth = 'none';
            lightboxImg.style.maxHeight = 'none';
            lightboxImg.style.cursor = 'zoom-out';
        } else {
            lightboxImg.style.transform = 'scale(1)';
            lightboxImg.style.maxWidth = '90vw';
            lightboxImg.style.maxHeight = '90vh';
            lightboxImg.style.cursor = 'zoom-in';
        }
    });

    // Close on background click
    lightbox.addEventListener('click', () => {
        lightbox.style.display = 'none';
        lightboxImg.src = '';
        lightboxImg.classList.remove('zoomed');
        lightboxImg.style.transform = 'scale(1)';
        lightboxImg.style.maxWidth = '90vw';
        lightboxImg.style.maxHeight = '90vh';
        lightboxImg.style.cursor = 'zoom-in';
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            lightbox.style.display = 'none';
            lightboxImg.src = '';
            lightboxImg.classList.remove('zoomed');
            lightboxImg.style.transform = 'scale(1)';
            lightboxImg.style.maxWidth = '90vw';
            lightboxImg.style.maxHeight = '90vh';
            lightboxImg.style.cursor = 'zoom-in';
        }
    });

    // Close on X button
    closeBtn.addEventListener('click', () => {
        lightbox.style.display = 'none';
        lightboxImg.src = '';
        lightboxImg.classList.remove('zoomed');
        lightboxImg.style.transform = 'scale(1)';
        lightboxImg.style.maxWidth = '90vw';
        lightboxImg.style.maxHeight = '90vh';
        lightboxImg.style.cursor = 'zoom-in';
    });
});
